import {CommonModule} from '@angular/common';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {NgModule, inject} from '@angular/core';
import {TokenInterceptor} from './token.interceptor';
import {HttpErrorInterceptor} from './httperror.interceptor';
import {CustomHeaderInterceptor} from './custom-headers.interceptor';

@NgModule({
  imports: [CommonModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      multi: true,
      useClass: CustomHeaderInterceptor,
    },
    {
      provide: HTTP_INTERCEPTORS,
      multi: true,
      useClass: TokenInterceptor,
    },
    {
      provide: HTTP_INTERCEPTORS,
      multi: true,
      useClass: HttpErrorInterceptor,
    },
  ],
})
export class GlobalServicesModule {
  constructor() {
    const parentModule = inject(GlobalServicesModule, {optional: true, skipSelf: true});

    if (parentModule) {
      throw new Error('GlobalServicesModule is already loaded. Import it in the AppModule only');
    }
  }
}
